import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  MARKET_PLACE_ID,
  ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP,
  ENCRYPTED_MARKETPLACE_ID,
  API_LIST: {
    MINIAPP_PROD,
    MINIAPP_GAMMA,
    EMTCSLP_EXTERNAL_APIGATEWAY_PROD,
    EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA
  }
} = constants;

const urls = {
  getGatewayModulesInfo: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/content/template`, // Obtain Home Shelf Components
  getDealsByIdList: `${MINIAPP_GAMMA}/dps/dealsByIdList`, // Obtain deal information based on the deal ID
  getDeals: `${MINIAPP_GAMMA}/dps/deals`, // get all deals
  getDealsItems: `${MINIAPP_GAMMA}/dps/deals/items`, // get deals items
  getWidgetHotKeys: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/content/widget/hotKeys`, // Get search keywords
  getWidgetPopup: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/content/widget/popup`, // Obtain pop-up advertising data
  getFloatingWindow: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/content/widget/floatingWindow`, // get gateway floating window
  getPageConfig: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/config/page`, // get app config page data
  getRecommendDeals: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/recommend/deals` // get Top deal ID
};

export const getDealsByIdList = (
  dealIds,
  marketplaceId = MARKET_PLACE_ID,
  status = 'VALID'
) => {
  const params = [
    `?marketplaceId=${marketplaceId}`,
    `status=${status}`,
    'eligibility=Y'
  ];
  dealIds.forEach(dealId => {
    if (!!dealId && typeof dealId === 'string') {
      params.push(`dealId=${dealId}`);
    }
  });
  return aHttp.get(urls.getDealsByIdList + params.join('&'));
};

export const getDeals = params => {
  const { limit, type, exclusiveStartKey } = params;
  const queryParams = [`marketplaceId=${MARKET_PLACE_ID}`, `limit=${limit}`];
  if (type) queryParams.push(`type=${type}`);
  if (exclusiveStartKey) {
    queryParams.push(
      `exclusiveStartKey=${encodeURIComponent(exclusiveStartKey)}`
    );
  }
  return aHttp.get(`${urls.getDeals}?${queryParams.join('&')}`);
};

export const getDealsItems = params => aHttp.get(urls.getDealsItems, params);
export const getGatewayModulesInfo = params =>
  aHttp.post(urls.getGatewayModulesInfo, params);
export const getWidgetHotKeys = params =>
  aHttp.get(urls.getWidgetHotKeys, params);
export const getWidgetPopup = params => aHttp.post(urls.getWidgetPopup, params);

export const getFloatingWindow = (params, header = {}) =>
  aHttp.get(urls.getFloatingWindow, params, header);

export const getPageConfig = () => {
  const params = {
    marketplaceId: ENCRYPTED_MARKETPLACE_ID,
    language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID]
  };
  return aHttp.get(urls.getPageConfig, params, {
    marketplaceId: ENCRYPTED_MARKETPLACE_ID
  });
};

export const getRecommendDeals = (params, header = {}) =>
  aHttp.get(
    urls.getRecommendDeals,
    {
      language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
      ...params
    },
    header
  );
